import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    template: `
        <ng-container *ngFor="let button of buttons; let first = first">
            <ng-container *ngIf="button?.type === 'button'">
                <button class="btn {{button?.color}} btn-sm" [class.ml-2]="!first"
                    (click)="click.emit({ data: rowData, id: button.id})">
                    <i *ngIf="button?.icon" class="fa {{button?.icon}}"></i> {{button?.text ? button.text : value}}
                </button>
            </ng-container>
            <div class="row" *ngIf="button?.type === 'a'">
                <a class="link" (click)="click.emit({ data: rowData, id: button?.id})">
                {{button?.text ? button.text : value}}
                </a>
            </div>
        </ng-container>
    `,
    styles: ['button { color: white !important }']
})
export class CustomButtonsCellComponent<T> {

    constructor() { }

    public buttons: {
        id: string,
        color: string,
        text: string,
        icon: string,
        type: string
    }[];

    @Input() rowData: T;
    @Input() value: string;

  /*eslint-disable */ @Output() click = new EventEmitter<{ data: any, id: string }>(); /*eslint-enable */
}
